export default {
  // list
  total: 0,
  pages: 1,
  page: 1,
  limit: 10,
  sortBy: 'id',
  sortDesc: false,
  list: [],

  // search
  conditions: {
    company: '',
    name: '',
    email: '',
    comment: '',
  },

  // edit
  form: {
    id: null,
    company: '',
    name: '',
    email: '',
    comment: '',
  },
};
